import { render, staticRenderFns } from "./OpportunityMapLegend.vue?vue&type=template&id=4a08787d"
var script = {}
import style0 from "./OpportunityMapLegend.vue?vue&type=style&index=0&id=4a08787d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports